import type { HistoryItem, PaginatedResponse } from "@/types";
import { api } from "../api";

export const historyService = {
  list: (params?: {
    types?: string;
    tags?: string;
    status?: string;
    sort?: string;
    page?: number;
    pageSize?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.types) searchParams.set("types", params.types);
    if (params?.tags) searchParams.set("tags", params.tags);
    if (params?.status) searchParams.set("status", params.status);
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    return api.get<PaginatedResponse<HistoryItem>>(`/history?${searchParams}`);
  },
};
